import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'

import PhotoSectionImage from '../../assets/PhotoSection/photo-section.png'

export const PhotoPage = () => {
  const { t } = useTranslation()

  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Photo section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={PhotoSectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
